import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { cpf, cnpj } from 'cpf-cnpj-validator';
import Apis from "../../../Apis";
import Loading from "../../../loading/Loading";
import { showAlert } from '../../../ui/dialog';
import { FiBriefcase, FiMail, FiPhone, FiHash, FiMapPin, FiDollarSign, FiPercent, FiUser, FiEdit, FiKey, FiSettings } from 'react-icons/fi';
import FormWizard from '../../../ui/FormWizard';
import { InputField, SelectField, FormRow } from '../../../ui/InputField';

const AlterarEmpresas = () => {
    const [cep, setCep] = useState('');
    const [cidade, setCidade] = useState('');
    const [bairro, setBairro] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [uf, setUf] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [razao, setRazao] = useState('');
    const [fantasia, setFantasia] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [ieRg, setIeRg] = useState('');
    const [tokenEmpresa, setTokenEmpresa] = useState('');
    const [ddd, setDdd] = useState('');
    const [financeiro, setFinanceiro] = useState('');
    const [desconto, setDesconto] = useState('');
    const [vendaClienteAutorizado, setVendaClienteAutorizado] = useState('');
    const [alterarPrecoVenda, setAlterarPrecoVenda] = useState('');
    const [cadastroMaiusculo, setCadastroMaiusculo] = useState('');
    const [validCpfCnpj, setValidCpfCnpj] = useState();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(r => r.json())
                .then(result => {
                    setCidade(result.localidade); setBairro(result.bairro);
                    setLogradouro(result.logradouro); setUf(result.uf);
                    setComplemento(result.complemento); setDdd(result.ddd);
                });
        }
        if (cpfCnpj.length >= 11 && cpfCnpj.length <= 18) {
            setValidCpfCnpj(cpf.isValid(cpfCnpj) || cnpj.isValid(cpfCnpj) ? true : false);
        }
    }, [cep, cpfCnpj]);

    useEffect(() => {
        setLoading(true);
        fetch(Apis.urlListarOneEmpresas, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": localStorage.getItem("id") })
        }).then(r => r.json()).then(result => {
            if (result.retorno.sucesso) {
                const e = result.registros[0];
                const parametros = e.parametros || {};
                setRazao(e.nome); setFantasia(e.fantasia);
                setCep(e.cep); setLogradouro(e.logradouro); setNumero(e.numero);
                setBairro(e.bairro); setComplemento(e.complemento); setCidade(e.cidade);
                setUf(e.uf); setEmail(e.email); setTelefone(e.telefone);
                setCpfCnpj(e.cnpj); setIeRg(e.ie); setTokenEmpresa(e.token);
                setFinanceiro(parametros.financeiro_venda); setDesconto(parametros.permite_desconto);
                setVendaClienteAutorizado(parametros.venda_cliente_autorizado);
                setAlterarPrecoVenda(parametros.altera_preco_pedido);
                setCadastroMaiusculo(parametros.cadastro_maiusculo);
                setLoading(false);
            } else {
                alertaErro(result.retorno.mensagem);
            }
        });
    }, []);

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    const handleSubmit = () => {
        if (validCpfCnpj === false || cpfCnpj.length < 11) { alertaErro("CPF/CNPJ inválido!"); return; }
        if (razao === '' || cpfCnpj === '') { alertaErro('Preencha os campos obrigatórios(*)'); return; }
        if (razao !== '' && cpfCnpj !== '' && validCpfCnpj === true) {
            const data = {
                "altera_preco_pedido": alterarPrecoVenda, "venda_cliente_autorizado": vendaClienteAutorizado,
                "cadastro_maiusculo": cadastroMaiusculo,
                "id": localStorage.getItem("id"), "permite_desconto": desconto, "financeiro_venda": financeiro,
                "nome": razao, "fantasia": fantasia, "logradouro": logradouro, "numero": numero,
                "cep": cep.length < 8 ? "1000000" : cep, "bairro": bairro, "complemento": complemento,
                "cidade": cidade, "uf": uf, "email": email, "fone": telefone, "cnpj": cpfCnpj, "ie": ieRg
            };

            fetch(Apis.urlAlterarEmpresa, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
                body: JSON.stringify(data)
            }).then(r => r.json()).then(result => {
                if (result.retorno.sucesso) {
                    navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-empresas`);
                } else {
                    alertaErro(result.retorno.mensagem);
                }
            });
        }
    };

    if (loading) return <Loading />;

    return (
        <FormWizard
            title="Alterar Empresa"
            icon={<FiBriefcase />}
            steps={['Identificação', 'Endereço', 'Configurações']}
            onSubmit={handleSubmit}
            submitLabel="Salvar Alterações"
        >
            {/* Passo 1 — Identificação */}
            <>
                <FormRow>
                    <InputField label="CPF / CNPJ" icon={<FiHash />} required
                        placeholder="CPF ou CNPJ" onChange={e => setCpfCnpj(e.target.value)} value={cpfCnpj} />
                    <InputField label="IE / RG" icon={<FiHash />}
                        placeholder="Inscrição Estadual ou RG" onChange={e => setIeRg(e.target.value)} value={ieRg} />
                </FormRow>
                <FormRow>
                    <InputField label="Razão Social" icon={<FiBriefcase />} required
                        placeholder="Razão Social" onChange={e => setRazao(e.target.value)} value={razao} />
                    <InputField label="Nome Fantasia" icon={<FiBriefcase />}
                        placeholder="Nome Fantasia" onChange={e => setFantasia(e.target.value)} value={fantasia} />
                </FormRow>
                <FormRow>
                    <InputField label="E-mail" icon={<FiMail />}
                        placeholder="E-mail" onChange={e => setEmail(e.target.value)} value={email} />
                    <InputField label="Telefone" icon={<FiPhone />}
                        placeholder="Telefone"
                        value={telefone}
                        onChange={e => {
                            if (telefone === '' && ddd !== '') setTelefone(`(${ddd}) ` + e.target.value);
                            else setTelefone(e.target.value);
                        }} />
                </FormRow>
            </>

            {/* Passo 2 — Endereço */}
            <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px', gap: 12 }}>
                    <InputField label="CEP" icon={<FiMapPin />}
                        placeholder="CEP (8 dígitos)" onChange={e => setCep(e.target.value)} value={cep} />
                    <InputField label="UF" placeholder="UF" onChange={e => setUf(e.target.value)} value={uf} />
                </div>
                <InputField label="Logradouro" icon={<FiMapPin />}
                    placeholder="Logradouro" onChange={e => setLogradouro(e.target.value)} value={logradouro} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <InputField label="Número" placeholder="Número" onChange={e => setNumero(e.target.value)} value={numero} />
                    <InputField label="Bairro" placeholder="Bairro" onChange={e => setBairro(e.target.value)} value={bairro} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <InputField label="Complemento" placeholder="Complemento" onChange={e => setComplemento(e.target.value)} value={complemento} />
                    <InputField label="Cidade" placeholder="Cidade" onChange={e => setCidade(e.target.value)} value={cidade} />
                </div>
            </>

            {/* Passo 3 — Configurações */}
            <>
                <FormRow>
                    <SelectField label="Informar Financeiro na Venda" icon={<FiDollarSign />}
                        onChange={e => setFinanceiro(e.target.value)} value={financeiro}>
                        <option value='0'>Sim</option>
                        <option value='1'>Não</option>
                    </SelectField>
                    <SelectField label="Permitir Desconto no Pedido" icon={<FiPercent />}
                        onChange={e => setDesconto(e.target.value)} value={desconto}>
                        <option value='0'>Sim</option>
                        <option value='1'>Não</option>
                    </SelectField>
                </FormRow>
                <FormRow>
                    <SelectField label="Venda somente para cliente autorizado" icon={<FiUser />}
                        onChange={e => setVendaClienteAutorizado(e.target.value)} value={vendaClienteAutorizado}>
                        <option value='0'>Sim</option>
                        <option value='1'>Não</option>
                    </SelectField>
                    <SelectField label="Permitir alterar preço na venda" icon={<FiEdit />}
                        onChange={e => setAlterarPrecoVenda(e.target.value)} value={alterarPrecoVenda}>
                        <option value='0'>Não Permitir</option>
                        <option value='1'>Permitir Alterar</option>
                        <option value='2'>Permitir Alterar Para Mais</option>
                    </SelectField>
                </FormRow>
                <SelectField label="Cadastro em maiúscula" icon={<FiSettings />}
                    onChange={e => setCadastroMaiusculo(e.target.value)} value={cadastroMaiusculo}>
                    <option value='0'>Não</option>
                    <option value='1'>Sim</option>
                </SelectField>
                <InputField label="Token da empresa" icon={<FiKey />}
                    value={tokenEmpresa} disabled readOnly />
            </>
        </FormWizard>
    );
};

export default AlterarEmpresas;
